import {useCallback, useEffect, useState} from "react";
import useAcquiredToken from "./useAcquiredToken";
import {SignInActivity} from "../domain/SignInActivity";

const useSignInActivities = () => {
    const { accessToken, loading: authLoading, error: authError, acquireToken } = useAcquiredToken();
    const [data, setData] = useState<Array<SignInActivity> | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [accountGuid, setAccountGuid] = useState<string>("");

    const fetchData = useCallback(async (accountGuid:string) => {
        if (!accountGuid) {
            return;
        }

        setAccountGuid(accountGuid);

        if (authLoading) {
            return;
        }  // Prevent API call if auth is still loading
        if (!accessToken) {
            return;
        }  // Prevent API call if no access token

        setLoading(true);
        setError(null);

        const fetchOptions = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const fullUrl = `${process.env.REACT_APP_GAS_URL}/account-health/${accountGuid}/signinactivity`;
        console.log(fullUrl);

        try {
            const response = await fetch(fullUrl, fetchOptions);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            setData(result);
            setLoading(false);
        } catch (err:any) {
            setLoading(false);
            if (err.message.includes('Failed to acquire token silently')) {
                // Optionally retry acquiring the token and the request
                console.error('Token acquisition failed:', err.message);
                await acquireToken(); // Retry acquiring token
                await fetchData(accountGuid); // Retry fetching data
            } else {
                console.log(err.message);
                setError('Error fetching data: ' + err.message);
            }
        }
    }, [accessToken, acquireToken, authLoading]);

    // // Fetch data when accessToken changes or on demand
    useEffect(() => {
        if (accessToken) {
            fetchData(accountGuid);
        }
    }, [accessToken, acquireToken, fetchData, accountGuid]);

    return { data, error, loading, fetchData };
};

export default useSignInActivities;
